import { HttpClient } from './HttpClient';
import type { Channel, ChannelsResponse } from '@/types/channel';

const API_URL = '/channels';

const channelsService = {
  async fetchChannels(): Promise<ChannelsResponse> {
    try {
      const response = await HttpClient.apiClient.get<ChannelsResponse>(API_URL);
      return response.data;
    } catch (error) {
      console.error('Error fetching channels:', error);
      throw new Error('Failed to fetch channels');
    }
  },

  async fetchChatChannels(): Promise<Channel[]> {
    try {
      const response = await this.fetchChannels();
      // Treat channels with type: null as chat channels based on the API response
      return response.data.filter(channel => channel.type === null || channel.type === 'chat');
    } catch (error) {
      console.error('Error fetching chat channels:', error);
      throw new Error('Failed to fetch chat channels');
    }
  },

  async fetchEmailChannels(): Promise<Channel[]> {
    try {
      const response = await this.fetchChannels();
      return response.data.filter(channel => channel.type === 'email');
    } catch (error) {
      console.error('Error fetching email channels:', error);
      throw new Error('Failed to fetch email channels');
    }
  }
};

export default channelsService; 